export const OCB = "OCB"
export const VIETTINBANK = "CTG"
export const SMARTPAY = "SMARTPAY"
export const FACEPAY = "FACEPAY"
export const PVCOMBANK = "PVCB"
export const TPBANK = "TPB"
export const BIDV = "BIDV";